import SidebarSubheading from './SidebarSubheading';

export default SidebarSubheading;
